import React, { useState, useEffect } from 'react';
import { DateBox } from 'devextreme-react';
import LVButtonAccion from '../Basicos/LVButtonAccion';
import LVCuadricula from '../Compuestos/Complejos/Generales/LVCuadricula';
import { function_ABM_ART_Tamanos_ListarDeArticulo } from 'neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_Tamanos';

function LVSelectorTamanos({ codigoArticulo, onSelectedCodigoChange }) {
  const [dataASeleccionar, setDataASeleccionar] = useState([]);
  const [loadingData, setLoadingData] = useState(false);


  useEffect(() => {
    const fetchGrupos = async () => {
      setLoadingData(true);
      try {
        const resultData = await function_ABM_ART_Tamanos_ListarDeArticulo(codigoArticulo);

        const resultUpdatedData = resultData.data.map(item => ({
          ...item,  // Copia todos los campos existentes
          Habilitado: true,  // Agrega el campo Habilitado con valor true
          Color: -14330269   // Agrega el campo Habilitado con valor true
        }));

        setDataASeleccionar(resultUpdatedData);
      } catch (error) {
        alert("Error al obtener los datos:" + error);
      } finally {
        setLoadingData(false); // Asegúrate de que se llame siempre
      }
    };

    fetchGrupos();
  }, []);

  const handleSelectorClick = async (codigo, descripcion) => {
    if (onSelectedCodigoChange) {
      onSelectedCodigoChange(codigo, descripcion);
    }
  };

  const handleCancel = () => {
    if (onSelectedCodigoChange) {
      onSelectedCodigoChange("", "");
    }
  };

  return (

    <div className="LV-Selectores-div">
      <table >
        <tbody>
          <tr>
            <td>
              <LVCuadricula
                data={dataASeleccionar}
                IdGrupo={0}
                CantidadDeBotonesHorizontal={6}
                AltoBotones={70}
                AnchoBotones={70}
                CampoCodigo={"CodigoTamano"}
                CampoDescripcion={"Descripcion"}
                onButtonClick={handleSelectorClick}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default LVSelectorTamanos;